var $ = jQuery.noConflict();
$(document).ready(function () {

	(function ($) {
		$(document).on('click', '.onetap-toggle', function (e) {
			e.stopPropagation();
			$('.onetap-plugin-onetap').toggleClass('active');
		});


		$(document).on('click', function (e) {
			var $pane   = $('.onetap-plugin-onetap');
			if (
				$pane.hasClass('active') &&
				$(e.target).closest('.onetap-plugin-onetap, .onetap-toggle').length === 0
			) {
				$pane.removeClass('active');
			}
		});


		function enhanceOneTap () {
			var $widget = $('.onetap-container');
			if (!$widget.length) { return; }

			if ($widget.find('.oneTap-close-btn').length === 0) {
				var $btn = $('<button>', {
					'class'      : 'oneTap-close-btn',
					'aria-label' : 'Zamknij widżet'
				}).html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="20" height="20" fill="currentColor"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>');
				$btn.on('click', function () { $('.onetap-plugin-onetap').removeClass('active'); });
				$widget.prepend($btn);

			}

			translateTexts();
		}

		var plDict = {
			'Accessibility Adjustments': 'Ustawienia dostępności',
			'Bigger Text'              : 'Większy tekst',
			'Cursor'                   : 'Kursor',
			'Letter Spacing'           : 'Odstępy między literami',
			'Readable Font'            : 'Czytelna czcionka',
			'Align Text'               : 'Wyrównanie tekstu',
			'Line Height'              : 'Wysokość linii',
			'colors'                   : 'kolory',
			'Grayscale'                : 'Skala szarości',
			'Brightness'               : 'Jasność',
			'Invert Colors'            : 'Odwróć kolory',
			'orientation'              : 'orientacja',
			'Highlight Links'          : 'Podświetl linki',
			'Stop Animations'          : 'Zatrzymaj animacje',
			'Hide Images'              : 'Ukryj obrazy',
			'Reading Mask'             : 'Maska czytelnicza',
			'Reading Line'             : 'Linijka czytelnicza',
			'Highlight All'            : 'Podświetl wszystko',
			'Reset Settings'           : 'Resetuj ustawienia',
			'Accessibility statement'  : 'Deklaracja dostępności'

		};


		function translateTexts () {
			var $root = $('.onetap-accessibility-settings');
			if (!$root.length) { return; }
			$root.find('*').contents().filter(function () {
				return this.nodeType === 3;
			}).each(function () {
				var txt = $.trim(this.nodeValue);
				if (plDict[txt]) { this.nodeValue = this.nodeValue.replace(txt, plDict[txt]); }
			});

		}


		var mo = new MutationObserver(function () {
			if ($('.onetap-toggle').length) { enhanceOneTap(); }
			translateTexts();
		});

		mo.observe(document.body, { childList: true, subtree: true });


	})(jQuery);

	function isMobile() {
		return window.innerWidth <= 768;
	}

	$('#billing_nip_field').insertAfter('#billing_city_field');

	if($('#brand-logo').length > 0) {
		$('#brand-logo').insertAfter('.entry-summary .price');
	}

	//scroll to first invalid field
	$(document.body).on('checkout_error', function () {
		var nip = $('form.checkout').find('.validate-nip');
		var zip = $('form.checkout').find('.validate-zip');

		var custom_key = $('form.checkout #custom_key');

		zip.each(function () {
			if (!validate_zip($(this).find('input').val()))
				$(this).removeClass('woocommerce-validated').addClass('woocommerce-invalid');
		});

		nip.each(function () {
			if (!validate_nip($(this).find('input').val()))
				$(this).removeClass('woocommerce-validated').addClass('woocommerce-invalid');
		});

		if ($(custom_key).val().length > 40) {
			$(custom_key).removeClass('woocommerce-validated').addClass('woocommerce-invalid');
		} else {
			$(custom_key).removeClass('woocommerce-invalid').addClass('woocommerce-validated');
		}

		if ($('form.checkout #customer_details .woocommerce-shipping-fields__field-wrapper').is(':visible')) {
			var invalid = $('form.checkout #customer_details p.woocommerce-invalid');
		} else {
			var invalid = $('form.checkout #customer_details .woocommerce-billing-fields p.woocommerce-invalid');
		}
		if (invalid.length > 0) {
			$('html, body').animate({
				scrollTop: $(invalid[0]).offset().top - 200
			}, 500);
		}

		//add messeges to error popup
		var $errors = $('.woocommerce-error').children();
		if ($errors.length > 0) {
			open_error_popup($errors);
		} else {
			close_error_popup();
		}

	});

	//on input custom key validation
	$("form.checkout #custom_key").bind('keyup', function (event) {
		if ($('form.checkout #custom_key').val().length > 40) {
			$('form.checkout #custom_key').removeClass('woocommerce-validated').addClass('woocommerce-invalid');
		} else {
			$('form.checkout #custom_key').removeClass('woocommerce-invalid').addClass('woocommerce-validated');
		}
	});

	$('.woocommerce-error-popup .woocommerce-error-popup--btn').click(close_error_popup);

	function open_error_popup(errors) {
		var $errors = $('.woocommerce-error').children();
		var $popup = $('.woocommerce-error-popup ul');
		$popup.children().remove();
		$popup.append($errors);

		$('.woocommerce-error-popup').show();
	}

	function close_error_popup() {
		var $popup = $('.woocommerce-error-popup ul');
		$popup.children().remove();

		$('.woocommerce-error-popup').hide();
	}

	function validate_nip(nip) {
		var nipWithoutDashes = nip.replace(/-/g, "");
		var reg = /^[0-9]{10}$/;
		if (reg.test(nipWithoutDashes) == false) {
			return false;
		} else {
			var digits = ("" + nipWithoutDashes).split("");
			var checksum = (6 * parseInt(digits[0]) + 5 * parseInt(digits[1]) + 7 * parseInt(digits[2]) + 2 * parseInt(digits[3]) + 3 * parseInt(digits[4]) + 4 * parseInt(digits[5]) + 5 * parseInt(digits[6]) + 6 * parseInt(digits[7]) + 7 * parseInt(digits[8])) % 11;

			return (parseInt(digits[9]) == checksum);
		}
	}

	function validate_zip(code) {
		code = code.replace(/-/g, "");
		var reg = /^\d\d\d\d\d$/;
		return reg.test(code);
	}

	//breadcrumbs
	$('.header-page .title-page .breadcrumbs .list-breadcrumbs > li .subcategory').each(function () {
		if ($(window).width() - 20 - ($(this).offset().left + $(this).outerWidth() + 20) < 0) {
			$(this).css('left', ($(window).width() - 20 - ($(this).offset().left + $(this).outerWidth() + 20)));
		}
	});

	//pagination
	$('nav.woocommerce-pagination').ready(function () {
		if ($('.woocommerce-products-header').find('.before_list').length <= 0) {
			$('.products_content').append($('.woocommerce-products-header'));
		}
	});

	var width = $(window).width();

	function openPaginateInput(e) {
		var $parent = $(this).parent();
		var $input = $parent.find('input');
		if ($input.length === 0) {
			$(this).hide();
			$parent.append('<input id="numbers-input" type="number" name="page-number" placeholder="..." maxlength="3" value="" class="page-numbers"></input>');
			setTimeout(function () {
				$parent.find('input').focus()
			}, 10);
		}
	}

	function closePaginateInput() {
		var $parent = $(this).parent();
		var number = $(this).val();
		if (number) {
			var path = location.pathname;
			var search = location.search;
			var base = location.origin;
			var brand = search.match(/brand=\w+/);
			var res = path.match(/page\/\d+\//);
			if (search.match(/\?product-page=\d+/) || path.match(/k\/\w+/)) {
				window.location.assign(base + path + '?product-page=' + number + (brand ? '&' + brand[0] : ''));
			} else if (path.match(/page\/\d+\//)) {
				window.location.assign(base + path.replace(/page\/\d+/, 'page/' + number) + (brand ? '?' + brand[0] : ''));
			} else {
				path += "/page/1/";
				window.location.assign(base + path.replace(/page\/\d+/, 'page/' + number) + (brand ? '?' + brand[0] : ''));
			}
		}
		// $parent.find('span').show();
		// $parent.find('input').remove();
	}

	//paginate input
	$('span.page-numbers.dots').hover(openPaginateInput, function () {
	});
	$(document).on("focusout", "input.page-numbers", closePaginateInput);
	$(document).on("keypress", "input.page-numbers", function (e) {
		var key = e.which;
		if (key == 13) {
			$('input.page-numbers').focusout();
			return false;
		}
	});

	var menuIcon = $('.hamburger-mobile > a');
	var menu = $('.header-main-nav');

	var searchIcon = $('.mini-search-menu a');
	var search = $('.header-mobile-search');


	$('.mini-search-menu a').click(function (e) {
		e.preventDefault();
		menu.slideUp();
		setTimeout(function () {
			$('.header-mobile-search').slideToggle();
			$('.wrapper').toggleClass('bigger');
			searchIcon.toggleClass('active');
			menuIcon.removeClass('active');
			$('.mobile_cat li').removeClass('active');
			$('.mobile_cat > .sub-menu > li').css('max-height', '60px');
			$('.mobile_cat > .sub-menu .sub-menu').slideUp();
		}, 300);

		if(isMobile()) {
			$('body').removeClass('no-scroll');
		}
	});

	$('.hamburger-mobile a').click(function (e) {
		e.preventDefault();
		menuIcon.toggleClass('active');
		searchIcon.removeClass('active');
		search.hide();
		$('.wrapper').removeClass('bigger');

		if(isMobile()) {
			$('body').toggleClass('no-scroll');
		}
	});

	function isMobile() {
		return $(window).width() <= 1024;
	}

	function animateSlide($slide) {
		$slide.find('.animate.first').animate({opacity: 1}, {
			duration: 1000, complete: function () {
				$slide.find('.animate.second').animate({opacity: 1}, {
					duration: 500, complete: function () {
						$slide.find('.animate.third').animate({opacity: 1}, {duration: 500})
					}
				});
			}
		});
	}

//temp
	var newsletter = $('p.comment-form-fm-sign');
	if (newsletter.length === 2 && newsletter[0].children.length === 2) {
		newsletter[0].remove();
	}

	$('.slider-mobile').on('click', function (e) {
		if(isMobile()) {
			var href = $(this).parent('.item').data('href');
			window.location.replace(href);
		}
	});

	var mainSlider = $('.main-slider').removeClass('hidden-until-ready').owlCarousel({
		loop: true,
		nav: true,
		dots: true,
		items: 1,
		autoplay: true,
		autoplayTimeout: 5000,
		autoplayHoverPause: false,
		onInitialized: function (event) {
			var $activeSlide = $(event.currentTarget).find('.owl-item.active');

			//nav black on init
			var nav = $(event.currentTarget).find('.owl-nav');

			if(!$activeSlide[0]) {
				return;
			}

			var item = $activeSlide[0].firstChild;

			nav.children().each(function () {
				if (item.dataset.color)
					$(this).css({'color': item.dataset.color});
				else
					$(this).css({'color': '#ffffff'});
			});

			//onClick go to slide link
			var allSlide = $(event.currentTarget).find('.owl-item');
			allSlide.each(function () {
				var item = this.firstChild;

				$(item.children[1]).on('mousedown', function (e) {
					$(this).data('p0', {x: e.pageX, y: e.pageY});
				}).on('mouseup', function (e) {
					if (e.which < 2) {
						var p0 = $(this).data('p0'),
							p1 = {x: e.pageX, y: e.pageY},
							d = Math.sqrt(Math.pow(p1.x - p0.x, 2) + Math.pow(p1.y - p0.y, 2));

						if (d < 4) {
							location.href = item.dataset.href;
						}
					}
				})

			});

			animateSlide($activeSlide)
		},
		onTranslate: function (event) {
			var $activeSlide = $(event.currentTarget).find('.owl-item.active');
			$activeSlide.stop(false, false);
			$activeSlide.find('.animate').css({'opacity': 0});

			mainSlider.trigger('stop.owl.autoplay');
		},
		onTranslated: function (event) {
			var $activeSlide = $(event.currentTarget).find('.owl-item.active');
			animateSlide($activeSlide);

			//change nav buttons color
			var item = $activeSlide.find('.item')[0];
			var nav = $(event.currentTarget).find('.owl-nav');

			nav.children().each(function () {
				if (item.dataset.color)
					$(this).css({'color': item.dataset.color});
				else
					$(this).css({'color': '#ffffff'});
			});

			//autoplay speed per slide
			this.settings.autoplayTimeout = $activeSlide.find('.item')[0].dataset.displayTime;
			mainSlider.trigger('play.owl.autoplay', [$activeSlide.find('.item')[0].dataset.displayTime]);
		}
	});

	var hotOfferHomepageSlider = $('.hot-offer-homepage_slider').removeClass('hidden-until-ready').owlCarousel({
		loop: true,
		nav: true,
		dots: true,
		items: 1,
		autoplay: true,
		autoplayTimeout: 5000,
		autoplayHoverPause: false,
		onInitialized: function (event) {
			var $activeSlide = $(event.currentTarget).find('.owl-item.active');

			//nav black on init
			var nav = $(event.currentTarget).find('.owl-nav');

			if(!$activeSlide[0]) {
				return;
			}

			var item = $activeSlide[0].firstChild;

			nav.children().each(function () {
				if (item.dataset.color)
					$(this).css({'color': item.dataset.color});
				else
					$(this).css({'color': '#ffffff'});
			});

			//onClick go to slide link
			var allSlide = $(event.currentTarget).find('.owl-item');
			allSlide.each(function () {
				var item = this.firstChild;

				$(item.children[1]).on('mousedown', function (e) {
					$(this).data('p0', {x: e.pageX, y: e.pageY});
				}).on('mouseup', function (e) {
					if (e.which < 2) {
						var p0 = $(this).data('p0'),
							p1 = {x: e.pageX, y: e.pageY},
							d = Math.sqrt(Math.pow(p1.x - p0.x, 2) + Math.pow(p1.y - p0.y, 2));

						if (d < 4) {
							location.href = item.dataset.href;
						}
					}
				})

			});

			animateSlide($activeSlide)
		},
		onTranslate: function (event) {
			var $activeSlide = $(event.currentTarget).find('.owl-item.active');
			$activeSlide.stop(false, false);
			$activeSlide.find('.animate').css({'opacity': 0});

			mainSlider.trigger('stop.owl.autoplay');
		},
		onTranslated: function (event) {
			var $activeSlide = $(event.currentTarget).find('.owl-item.active');
			animateSlide($activeSlide);

			//change nav buttons color
			var item = $activeSlide.find('.item')[0];
			var nav = $(event.currentTarget).find('.owl-nav');

			nav.children().each(function () {
				if (item.dataset.color)
					$(this).css({'color': item.dataset.color});
				else
					$(this).css({'color': '#ffffff'});
			});

			//autoplay speed per slide
			this.settings.autoplayTimeout = $activeSlide.find('.item')[0].dataset.displayTime;
			hotOfferHomepageSlider.trigger('play.owl.autoplay', [$activeSlide.find('.item')[0].dataset.displayTime]);
		}
	});

	$('#hot_offer, #hot_offer2').owlCarousel({
		loop: true,
		nav: true,
		navElement: 'div',
		navText: ['‹', '›'],
		dots: false,
		autoplay: true,
		margin: 5,
		autoplayTimeout: hotOfferSpeed ? hotOfferSpeed : 5000,
		autoplayHoverPause: true,
		responsive: {
			0: {
				items: 2
			},
			400: {
				items: 2
			},
			600: {
				items: 3
			},
			768: {
				items: 4
			},
			1024: {
				items: 2
			}
		}
	});

	$('.owl-slider-hot-offers').owlCarousel({
		loop: true,
		nav: true,
		navElement: 'div',
		navText: ['‹', '›'],
		dots: false,
		autoplay: true,
		margin: 5,
		autoplayTimeout: hotOfferSpeed,
		autoplayHoverPause: true,
		responsive: {
			0: {
				items: 1
			},
			400: {
				items: 1
			},
			768: {
				items: 1
			},
			1024: {
				items: 1
			}
		}
	});

	var $gallerySlider = $(".gallery-thumbnails-slider");
	var $navSlider = $(".gallery-thumbnails-navigation");

	function offsetIndex(index, $from) {
		var all = $from.find('.owl-stage').children().length;
		var clones = $from.find('.owl-stage').find('.cloned').length;
		var off = 0;
		var normal = all - clones;
		$from.find('.owl-stage').children().each(function () {
			if ($(this).hasClass('cloned')) {
				off += 1;
			} else {
				return false;
			}
		});
		off = Math.floor(off);
		index -= off;
		if (index > normal - 1) {
			index -= normal;
		} else if (index < 0) {
			index += normal;
		}
		return Math.floor(index);
	}

	function setSliderItem(index, $target) {
		$target.trigger('to.owl.carousel', [index, 300, true]);
	}

	if ($gallerySlider.children().length > 0) {

		var slides = $gallerySlider.owlCarousel({
			loop: $gallerySlider.children().length > 1,
			nav: true,
			dots: false,
			autoplay: false,
			items: 1,
			checkVisible: false,
		});
		$gallerySlider.on('changed.owl.carousel', function (e) {
			setSliderItem(offsetIndex(e.item.index, $gallerySlider), $navSlider);
		});

		if ($gallerySlider.children().length > 1) {
			var thumbs = $navSlider.owlCarousel({
				items: 4,
				loop: $navSlider.children().length > 3 ? true : false,
				margin: 10,
				autoplay: false,
				nav: true,
				dots: false
			}).on('click', '.owl-item', function (e) {
				e.preventDefault();
				var index = $(e.target).parents('.owl-item').index();
				setSliderItem(offsetIndex(index, $navSlider), $gallerySlider);
			}).data('owl.carousel');
		}
	} else {
		$('.gallery-thumbnails').remove();
	}

	$('div.product-upsells-item').on('mousedown', function (e) {

		if (e.target.nodeName !== "A" && e.target.nodeName !== "IMG") {
			var thisdata = $(this).data('href');

			if (e.which == 1) {
				window.location.href = thisdata;
			}

			if (e.which == 2) {
				window.open(thisdata, '_blank');
			}
		}
	});

	$('a.collapsed').click(function (e) {
		e.preventDefault();
		$(this).toggleClass('in').parents('.panel-default').find('.panel-collapse').toggleClass('in');
	});

	$('.btn-table-content a').click(function (e) {
		e.preventDefault();
		var $content = $(this).parent();
		$content.toggleClass('opened');
		$content.find('i.fas').toggleClass('fa-plus');
		$content.find('i.fas').toggleClass('fa-minus');
		$(this).parents('.product').find('.table-more-products').slideToggle(400);
	});

	$('#about_us .description-content .description .read-more').click(function (e) {
		e.preventDefault();
		$(this).toggleClass('active').parent().toggleClass('in');
	});

	$('.hamburger-mobile a').click(function (e) {
		e.preventDefault();
		$('.header .header-main-nav').slideToggle();
	});

	$('.header .header-main-nav ul.menu > li.menu-item-has-children').click(function (e) {
		var $this = $(e.target);

		if($this.hasClass('mobile_cat__scroll')) {
			return;
		}

		$this.toggleClass('active');

		//close others
		$this.parent().find('> li').not($this).removeClass('active');
		$this.parent().find('> li').not($this).find('> ul').slideUp();

		if(!$this.parent().hasClass('menu-sidebar')) {
			$this.find('ul.sub-menu').first().slideToggle();
		} else {
			if($this.hasClass('active')) {
				// $this.parent().find('> li').find('ul').slideDown();
				$this.parent().find('> li').not($this).css('max-height', '0px');
			} else {
				$this.parent().find('> li').not($this).css('max-height', '60px');
				// $this.parent().find('.sub-menu').slideUp();
			}
		}
	});

	// $('.menu-sidebar.menu > li').click(function (e) {
	// 	if (isMobile() && !$(e.target).is('a')) {
	// 		e.preventDefault();
	// 		e.stopPropagation();
	// 		$(e.target).css('max-height', 'unset');
	//
	// 		if(!$(e.target).hasClass('active')) {
	// 			$(e.target).find('ul').first().slideUp();
	// 		} else {
	// 			$(e.target).find('ul').first().slideDown();
	// 		}
	// 	}
	// });
	//
	// $('.menu-sidebar.menu > li ul li').click(function (e) {
	// 	if (isMobile() && !$(e.target).is('a')) {
	// 		var $this = $(this);
	// 		e.preventDefault();
	// 		e.stopPropagation();
	//
	// 		$this.toggleClass('active');
	// 		$this.find('ul.sub-menu').first().slideToggle();
	//
	// 		$this.siblings().find('ul.sub-menu').slideUp(400);
	// 		$this.siblings().removeClass('active');
	//
	// 		// var scroll_top = $this.offset().top - $('.mobile_cat > ul').offset().top + $('.mobile_cat > ul').scrollTop();
	// 		// $('.mobile_cat > ul').animate({scrollTop: scroll_top }, 'slow');
	// 	}
	// });


	$('.variationimg').click(function (e) {
		e.preventDefault();
		$('.woocommerce-product-gallery__trigger').trigger('click');
	});

	$(document).on('click', '.woocommerce-product-gallery__image', function () {
		$('.woocommerce-product-gallery__trigger').trigger('click');
	});

	$('#vt_added_to_cart_notification').remove();

	//ajax add to cart
	$(document.body).on('mini_cart_refreshed', function () {
		$.unblockUI();
	});

	$(document.body).on('wc_fragments_refresh', function (e) {
		// //when updating cart from woo-variation plugin
		// var key = Object.keys(sessionStorage).filter(function (k) {
		// 	return k.includes('fragments') && !k.includes('fragments_')
		// })[0];
		// if (e.currentTarget.baseURI.includes("koszyk")) {
		// 	//when updating cart from woocommerce e.g removing from cart
		// 	var key = Object.keys(sessionStorage).filter(function (k) {
		// 		return k.includes('fragments_')
		// 	})[0];
		// }
		// var fragments = JSON.parse(sessionStorage.getItem(key));
		// if (fragments) {
		// 	var minicart = $($.parseHTML(fragments["div.widget_shopping_cart_content"])).find('ul.woocommerce-mini-cart')[0];
		// 	var count = fragments.cart_contents_count;
		//
		// 	if ($('ul.woocommerce-mini-cart').length < 1) {
		// 		$('div.card-menu-hover').empty();
		// 		$('div.card-menu-hover').append(minicart);
		// 		$('div.card-menu-hover').append('<div class="woocommerce-mini-cart__buttons buttons"><a href="http://bionovo.pl/koszyk/" class="button wc-forward"><div class="button-text">Przejdź do zamówienia <br>lub zapytania ofertowego</div></a></div>')
		// 	} else {
		// 		if (count == 0) {
		//
		// 		}
		// 		$('ul.woocommerce-mini-cart').replaceWith(minicart);
		// 	}
		// 	if ($('a.link-menu .badge').length < 1) {
		// 		$('a.link-menu').append('<span class="badge">' + count + '</span>');
		// 	} else {
		// 		$('a.link-menu .badge').html(count);
        //         $('a.link-menu .badge').show();
		// 	}
		//
		// 	if (count == 0) {
		// 		$('a.link-menu .badge').remove();
		// 		$('div.card-menu-hover').empty();
		// 		$('div.card-menu-hover').append('<p class="woocommerce-mini-cart__empty-message">Brak produktów w koszyku</p>');
		// 	}
		// } else {
		// 	$('a.link-menu .badge').remove();
		// 	$('div.card-menu-hover').empty();
		// 	$('div.card-menu-hover').append('<p class="woocommerce-mini-cart__empty-message">Brak produktów w koszyku</p>');
		// }
		// getCartCount();
	});

	$('.single_add_to_cart_button').click(function (e) {
		setTimeout(function () {
			blockUI('Dodaję do koszyka');
		}, 0);

		setTimeout(function () {
			$('.single_add_to_cart_button').tooltip("close");
			getCartCount();
		}, 1000);
	});

	// $(document).on('touchend', function (e) {
	//    if($(e.target).not('.single_add_to_cart_button')){
	//        $('.single_add_to_cart_button').tooltip("close");
	//    }
	// });

	function blockUI(message) {
		$.blockUI({
			message: '<img src="' + document.location.origin + '/wp-content/themes/bionovo/img/loader.gif?v="' + Date.now() + '/>' + message,
			css: {
				border: 'none',
				padding: '10px 45px',
				backgroundColor: 'rgb(224, 222, 222)',
				color: '#333',
				'-webkit-border-radius': '10px',
				'-moz-border-radius': '10px',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				fontSize: '17px'
			}
		});
	}

	function openModal(type) {
		$('.mysticky-block-right').hide();
		var modal = $('#cart-modal');
		var order = modal.find('span.order');
		var offer = modal.find('span.offer');
		if (type === "order") {
			order.removeClass('hidden');
		}
		if (type === "offer") {
			offer.removeClass('hidden');
		}
		modal.removeClass('hidden');
	}

	function closeModal() {
		$('.mysticky-block-right').show();
		var modal = $('#cart-modal');
		modal.find('span.order').addClass('hidden');
		modal.find('span.offer').addClass('hidden');
		modal.addClass('hidden');
	}

	$('.checkout-button.button.alt.wc-forward').click(function (e) {
		// openModal('order');
	});

	$('#cart-modal').click(function (e) {
		if (e.srcElement === this)
			closeModal();
	});

	function debounce(func, wait, immediate) {
		var timeout;
		return function () {
			var context = this, args = arguments;
			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}

	function onQtyChange() {
		$('[name="update_cart"]').trigger('click');
	}

	function onMinusClick() {
		var parent = $(this).parent();
		var input = $(parent).find('input');
		var value = $(input).val();

		if (value != 0 && value > 0) {
			value--;
			$('[name="update_cart"]').prop('disabled', false);
		}

		$(input).val(value);

		debounce(function () {
			$('[name="update_cart"]').trigger('click');
		}, 500)();
	}

	function onPlusClick() {
		var parent = $(this).parent();
		var input = $(parent).find('input');
		var value = $(input).val();

		if (value != 999 && value < 999) {
			value++;
			$('[name="update_cart"]').prop('disabled', false);
		}

		$(input).val(value);

		debounce(function () {
			$('[name="update_cart"]').trigger('click');
		}, 500)();
	}

	$(document.body).on('updated_wc_div', function () {
		$('.product-quantity .minusqty').click(onMinusClick);

		$('.product-quantity .plusqty').click(onPlusClick);

		$('.qty').change(onQtyChange);
	});

	$('.product-quantity .minusqty').click(onMinusClick);

	$('.product-quantity .plusqty').click(onPlusClick);

	$('.qty').change(onQtyChange);

	$('a.button-under-separator:not(".foo")').click(function (e) {
		e.preventDefault();
		$(this).find('i.fas').toggleClass('fa-plus');
		$(this).find('i.fas').toggleClass('fa-minus');
		if ($(this).hasClass('up')) {
			$('span.toggle-heading.on-closed:visible').click()
		} else {
			$('span.toggle-heading.on-opened:visible').click()
		}
		$(this).toggleClass('up');
		$(this).toggleClass('down');
	});


	$('.menu-sidebar .menu-item-has-children').hover(
		function () {
			if (isMobile()) return;
			var theHover = $(this).find('ul').first();
			var offset = theHover.offset();

			if (!offset) {
				return;
			}

			var top = offset.top;
			var scroll = $(window).scrollTop();
			var subheight = theHover.height();
			var admin_bar = $('#wpadminbar').length ? $('#wpadminbar').height() : 0;
			var windowheight = $(window).height();
			var lack = windowheight - (top + subheight - scroll);
			var minuslack = subheight - windowheight + (scroll > 0 ? 87 : 128) + admin_bar;

			if (minuslack < 0) {
				minuslack = 0;
			}

			if (lack < 0) {
				theHover.css('top', (lack + minuslack));
			}
		},
		function () {
			var theHover = $(this).find('ul').first();
			theHover.css('top', 0);
		}
	);

	// $('.menu-sidebar .menu-item-has-children').hover(
	// 	function () {
	// 		if (isMobile()) return;
	//
	// 		var theHover = this;
	// 		var subMenu = $(theHover).find('.sub-menu').first();
	// 		var subMenuHeight = subMenu.height();
	// 		var sidebar = $('.sidebar');
	// 		var sidebarHeight = sidebar.height();
	// 		var offset = sidebar.offset();
	// 		var scrollTop = $(window).scrollTop();
	// 		var adminBarHeight = $('#wpadminbar').height() || 0;
	//
	// 		if (subMenuHeight > sidebarHeight) {
	// 			subMenu.css({
	// 				'top': -(offset.top - scrollTop - adminBarHeight),
	// 				'left': '100px',
	// 				'width': '100%',
	// 				'max-width': 'none'
	// 			});
	// 		}
	// 	},
	// 	function () {
	// 		var theHover = this;
	// 		var subMenu = $(theHover).find('.sub-menu').first();
	// 		subMenu.css({
	// 			'top': '1',
	// 			'left': '100%',
	// 		});
	// 	}
	// );


	// test



	$('#fm-sign').addClass('woocommerce-form__input').addClass('woocommerce-form__input-checkbox').addClass('input-checkbox');
	$('#fm-sign').parent().addClass('woocommerce-form__label').addClass('woocommerce-form__label-for-checkbox').addClass('checkbox');
	var text = $('#fm-sign').parent().text();
	$('#fm-sign').parent().html($('#fm-sign').parent().children());
	$('#fm-sign').parent().append('<span>' + text + '</span>');
	$('#fm-sign').parent().find('br').remove();

	$('.single_add_to_cart_button').tooltip();
	$('.for-quote').tooltip();


	if ($('#fvm-header-1').length > 0) {
		$('header').append($('#fvm-header-1'));
	}

	var openPhotoSwipe = function (item) {

		// build items array
		var items = [];
		var $img = $(item).find('img');
		items.push({
			src: $(item).attr('href'),
			w: parseInt($img.attr('data-large_image_width')) || 0,
			h: parseInt($img.attr('data-large_image_height')) || 0,
		});

//        console.log(items);

		// define options (if needed)
		var options = {
			// history & focus options are disabled on CodePen
			history: false,
			focus: false,

			showAnimationDuration: 0,
			hideAnimationDuration: 0,
			closeOnScroll: false
		};

		var gallery = new PhotoSwipe($('.pswp')[0], PhotoSwipeUI_Default, items, options);
		gallery.init();
	};

	$('[data-rel="prettyPhoto"]').click(function () {
		openPhotoSwipe(this);
	});

	$('.gallery-thumbnails-slider .product-image-slider').on('click', function (e) {
		e.preventDefault();
		var $this = $(this);
		var href = $this.attr('href');
		var imageCollection = $('.gallery-thumbnails-slider .owl-item:not(.cloned) .product-image-slider').toArray();
		var indexOfItem = imageCollection.map(function (v) {
			return $(v).attr('href');
		}).indexOf(href);
		var items = imageCollection.map(function (v) {
			var $elem = $(v);
			var $img = $elem.find('img');

			return {
				src: $elem.attr('href'),
				w: parseInt($img.attr('data-large_image_width')),
				h: parseInt($img.attr('data-large_image_height')),
			};
		});

		var gallery = new PhotoSwipe($('.pswp')[0], PhotoSwipeUI_Default, items, {
			closeOnScroll: false,
			index: indexOfItem
		});
		gallery.init();
		gallery.listen('afterChange', function () {
			setSliderItem(gallery.getCurrentIndex(), $gallerySlider);
		});
	});


	$('.shop_table .product-thumbnail img').on('click', function (e) {
		e.preventDefault();
		var $this = $(this);
		var href = $this.parents().attr('data-hq-src');
		if (href) {
			console.log(href);
			var items = [];
			items.push({

				src: href,
				w: 0,
				h: 0,

			});

			var gallery = new PhotoSwipe($('.pswp')[0], PhotoSwipeUI_Default, items, {
				closeOnScroll: false
			});


			gallery.listen('imageLoadComplete', function (index, item) {
				if (item.w < 1 || item.h < 1) {
					var img = new Image();
					img.onload = function () {
						item.w = this.width;
						item.h = this.height;
						gallery.updateSize(true);
					};
					img.src = item.src;
				}
			});

			gallery.init();
		}
	});

	$('div.wysiwyg img').on('click', function (e) {
		e.preventDefault();
		var $this = $(this);
		var href = $(this).parent().attr('href');
		var items = [];
		items.push({

			src: href,
			w: 0,
			h: 0,

		});

		var gallery = new PhotoSwipe($('.pswp')[0], PhotoSwipeUI_Default, items, {
			closeOnScroll: false
		});


		gallery.listen('imageLoadComplete', function (index, item) {
			if (item.w < 1 || item.h < 1) {
				var img = new Image();
				img.onload = function () {
					item.w = this.width;
					item.h = this.height;
					gallery.updateSize(true);
				};
				img.src = item.src;
			}
		});

		gallery.init();

	});

	var desc = $('#tab-description');
	if (desc.length) {
		var children = desc.children();

		for (var i = children.length - 1; i >= 0; --i) {
			if (children[i].innerHTML.indexOf("<br>") !== -1) {

				var lastEl = children[i].childNodes;
				for (var j = lastEl.length - 1; j >= 0; --j) {
					if (lastEl[j].tagName === "BR") {
						lastEl[j].remove();
					} else if (lastEl[j].nodeName === "#text" && !lastEl[j].nodeValue.replace(/\s/g, '').length) {
						lastEl[j].remove();
					} else {
						break;
					}
				}

				if (children[i].innerHTML.length === 0)
					children[i].remove();

			} else if (children[i].innerHTML.trim().indexOf("&nbsp;") === 0) {
				children[i].remove();
			} else {
				break;
			}
		}
	}

	$('.col__9').append($('.woocommerce-pagination'));

	$('.menu-sidebar > div > ul li').mouseenter(function () {
		var obj = this;

		clearTimeout(window.theSitebarTimeout);
		window.theSitebarTimeout = setTimeout(function () {

			var classCss = 'overon-' + $(obj).parents('li').length;

			$('.' + classCss).removeClass(classCss);
			$(obj).addClass(classCss);

		}, 500);


	});

	$('.menu-sidebar > div > ul li').mouseleave(function () {
		clearTimeout(window.theSitebarTimeout);

	});


	$('.header .header-main-nav ul.menu > li').hover(
		function () {
			$('.overon').removeClass('overon');
			$(this).addClass('overon');
		},
		function () {

		}
	);

	$('.login-menu-item-contents .bionovo-login-username, .login-menu-item-contents .bionovo-login-password').focus(function () {
		$('.login-menu-item-contents').addClass('force-open');
	});

	$('.login-menu-item-contents .bionovo-login-username, .login-menu-item-contents .bionovo-login-password').blur(function () {
		$('.login-menu-item-contents').removeClass('force-open');
	});

	$('.product_jump button').click(function () {
		$('html, body').animate({
			scrollTop: ($(".table.vartable").offset().top - 150)
		}, 1000);
	});

	$(window).on('load resize', function () {
		if ($(this).width() <= 768) {
			var tr = $('.table.vartable').find('tr');

			$(tr).each(function () {
				var form = $(this).find('.cartcol form'),
					wrap = $(this).find('.qtywrap');

				$(form).appendTo(wrap);
			});

			$('.cartcol').hide();
		} else {
			var tr = $('.table.vartable').find('tr');

			$(tr).each(function () {
				var form = $(this).find('.qtywrap form'),
					cartcol = $(this).find('.cartcol--wrapper');

				$(form).appendTo(cartcol);
			});

			$('.cartcol').show();
		}
	});

	$('.footer .title.flex-title:not(.visible)').on('click', function (e) {
		if ($(window).width() <= 600) {
			e.preventDefault();
			$(this).find('i.fas').toggleClass('fa-angle-down');
			$(this).find('i.fas').toggleClass('fa-minus');
			$(this).parent().find('div:not(.title)').slideToggle();
		}
	});


	var renderRecent = {
		init: function () {
			var ls = this.readLS('recently_viewed');

			if (ls) {
				this.ajax(ls);
				this.saveCookie(ls);
			}
		},

		readCookie: function () {
			var name = 'woocommerce_recently_viewed',
				nameEQ = name + '=',
				ca = document.cookie.split(';');

			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) === ' ') c = c.substring(1, c.length);
				if (c.indexOf(nameEQ) === 0) return decodeURI(c.substring(nameEQ.length, c.length));
			}
			return false;
		},

		readLS: function (key) {
			if (!('localStorage' in window)) return;
			return window.localStorage.getItem(key);
		},

		saveLS: function (key, val) {
			if (!('localStorage' in window)) return;

			var ls = this.readLS(key);

			if (ls) {
				ls = JSON.parse(ls);
			} else {
				ls = [];
			}

			if (ls.indexOf(val) < 0) {
				ls.push(val);
			}

			if (ls.length > 10) {
				ls.shift()
			}

			localStorage.setItem(key, JSON.stringify(ls));
		},

		saveCookie: function (val) {
			var date = new Date();
			date.setTime(date.getTime() + (30 * 60 * 1000));
			var expires = "; expires=" + date.toUTCString();
			document.cookie = "woocommerce_recently_viewed=" + val + expires + "; path=/";
		},

		ajax: function (products) {
			$.ajax({
				url: window.ajaxurl,
				type: 'POST',
				data: {
					'action': 'render_recent',
					'products': JSON.parse(products)
				},
				success: function (response) {
					var wrapper = $('#recent_products');

					$('.recent_products_wrapper').show();
					$(wrapper).append(response.data.html);
					$(wrapper).owlCarousel({
						loop: true,
						nav: true,
						navElement: 'div',
						navText: ['‹', '›'],
						dots: false,
						autoplay: true,
						margin: 5,
						autoplayTimeout: recentlySeenSpeed,
						autoplayHoverPause: true,
						responsive: {
							0: {
								items: 2
							},
							400: {
								items: 2
							},
							600: {
								items: 3
							},
							768: {
								items: 4
							},
							1024: {
								items: 2
							}
						}
					});
				}
			});
		}
	}

	if ($('.single-product').length > 0) {
		var id = $('.single-product').find('.product').attr('id').split('-');

		if (id[1]) {
			renderRecent.saveLS('recently_viewed', id[1]);
		}
	}

	if ($('#recent_products').length > 0) {
		renderRecent.init();
	}

	if ($('.woocommerce-Tabs-panel').length > 0) {
		$('.woocommerce-Tabs-panel').each(function (index) {
			var table = $(this).find('table');

			if (table.length > 0) {
				table.each(function () {
					$(this).wrap('<div class="table-wrapper"></div>');
				})
			}
		})
	}

	$('.var-tag, .pricecol').tooltip();
	$('.pricecol').tooltip();

    var wishlist = {
        loggedIn: $('body').hasClass('logged-in'),

        init: function () {
            var ls = this.readLS('user_wishlist');

            if(ls){
                this.readWishlist(ls);
            }

			this.markWishlistButtons();
            this.updateWishlistListener();
        },

        readLS: function (key) {
            if (!('localStorage' in window)) return;
            return window.localStorage.getItem(key);
        },

        saveLS: function (key, val) {
            if (!('localStorage' in window)) return;
            localStorage.setItem(key, val);
        },

        readWishlist: function () {
            if(!this.loggedIn){
                localStorage.setItem('user_wishlist', '[]');
                return;
            }

            $.ajax({
                url: window.ajaxurl,
                type: 'POST',
                data: {
                    'action': 'read_wishlist',
                },
                success: function (response) {
                    wishlist.saveLS('user_wishlist', response.data.wishlist);
                }
            });

            this.markWishlistButtons();
        },

        markWishlistButtons: function () {
            if(!this.loggedIn) {
                $('.wishlist-btn').each(function (){
                    $(this).addClass('locked');
                    $(this).attr('title', 'Aby dodać produkty do listy ulubionych, musisz się zalogować.');
					$(this).tooltip();
				})

				return;
            }

            var ls = this.readLS('user_wishlist');

            if(ls){
                $('.wishlist-btn:not(.wishlist-btn--remove)').each(function (){
                    var id = $(this).data('varid');

                    if(ls.indexOf(id) > -1){
                        $(this).addClass('active');
						$(this).attr('title', 'Usuń z ulubionych');
					}
                })
            }

			$('.wishlist-btn').tooltip();
        },

        updateWishlistListener: function () {
            $('.wishlist-btn').each(function (){
                var id = $(this).data('varid');
                var $this = $(this);

                $(this).on('click', function (){
                    $.ajax({
                        url: window.ajaxurl,
                        type: 'POST',
                        data: {
                            'action': 'update_wishlist',
							'variation_id': id,
                        },
                        success: function (response) {
                            wishlist.saveLS('user_wishlist', response.data.wishlist);

                            if(response.data.type === 'add') {
                                $this.addClass('active');
								$this.attr('title', 'Usuń z ulubionych');
                            } else {
                                $this.removeClass('active');
								$this.attr('title', 'Dodaj do ulubionych');

								if($this.hasClass('wishlist-btn--remove')) {
									$('tr.wishlist_item[data-varid="' + id + '"]').remove();
								}
                            }
                        }
                    });
                });
            })
        },
    }
	wishlist.init();

	function smoothScroll(elementId) {
		var element = document.getElementById(elementId);
		if (element) {
			var headerHeight = $('.container--header').height();
			var elementPosition = element.offsetTop;
			var offsetPosition = elementPosition - headerHeight;

			window.scrollTo({
				top: offsetPosition,
				behavior: "smooth"
			});
		}
	}

	if (window.location.hash) {
		var hash = window.location.hash.substring(1);
		smoothScroll(hash);
	}

	$('a[href*="#"]').on('click', function (e) {
		e.preventDefault();
		var href = $(this).attr('href');
		var hash = href.substring(href.indexOf('#') + 1);

		if ($(this).parent().prop('tagName') !== 'LI') {
			smoothScroll(hash);
		}
	});

	var cartRotator = $('.cart-banners-rotator');

	if (cartRotator.length > 0) {
		cartRotator.owlCarousel({
			loop: true,
			autoplay: true,
			autoplayTimeout: 5000,
			autoplayHoverPause: true,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			dots: false,
			nav: false,
			margin: 20,
			responsive : {
				0:{
					items: 1
				},
				768 : {
					items : 2
				}
			}
		});
	}

	var sidebarFiller = $('.sidebar__filler');

	if(sidebarFiller.length > 0) {
		var promoSliders = $('.promo-slider');

		if(promoSliders.length > 0) {
			var randomSlider = Math.floor(Math.random() * promoSliders.length);
			console.log(randomSlider);
			$(promoSliders[randomSlider]).addClass('active');
		}
	}

	$(document.body).trigger('wc_fragments_refresh');
	$(document.body).on( 'removed_from_cart', function () {
		getCartCount()
	});
	$(document.body).on('updated_wc_div', function(){
		getCartCount();
	});

    $('.product-tag, .tag-image').tooltip();

    function breadcrumbsOnScroll () {
        var headerPage = $('.header-page');
        var containerRight = $('.container-right');
        var headerTopBar = $('.header-top-bar');
        var contentHeader = $('.container--header');


        window.addEventListener('scroll', function () {
            var scrollPosition = window.scrollY;

            if (scrollPosition > 0) {
                headerPage.addClass('header-active');
                headerTopBar.addClass('header-active');
                contentHeader.addClass('header-active');
                containerRight.addClass('header-active');
            } else {
                headerPage.removeClass('header-active');
                headerTopBar.removeClass('header-active');
                contentHeader.removeClass('header-active');
                containerRight.removeClass('header-active');
            }
        });
    }
    breadcrumbsOnScroll();

	var $cartUpsells = $('#cartUpsells');

	$cartUpsells.owlCarousel({
		loop: true,
		nav: true,
		navElement: 'div',
		navText: ['‹', '›'],
		dots: false,
		autoplay: true,
		margin: 5,
		autoplayTimeout: recentlySeenSpeed,
		autoplayHoverPause: true,
		responsive: {
			0: {
				items: 2
			},
			400: {
				items: 2
			},
			600: {
				items: 3
			},
			768: {
				items: 3
			},
			1024: {
				items: 3
			}
		}
	});

    if($('#upsell-products')) {
        $.ajax({
            url: window.ajaxurl,
            type: 'POST',
            data: {
                action: 'load_upsell_products',
                post_id: post_id
            },
            success: function (response) {
                if(response.success) {
                    $('#related-loader').hide();
                    $('#upsell-products').html(response.data.html);
                }
            },
        });
    }


    if($('#related-products')) {
        $.ajax({
            url: window.ajaxurl,
            type: 'POST',
            data: {
                action: 'load_related_products',
                post_id: post_id
            },
            success: function (response) {
                if(response.success) {
                    $('#related-loader').hide();
                    $('#related-products').html(response.data.html);
                    slideDownRelated();
                }
            },
        });
    }
});